import React from "react";
import { Box, Container, Typography, Grid, Card, CardContent, Avatar } from "@mui/material";
import { motion } from "framer-motion";

const teamMembers = [
    {
        name: "Marcus Thompson",
        role: "Senior Network Engineer",
        description: "With over 12 years of experience in enterprise networking, Marcus specializes in designing and implementing high-performance network infrastructures for Fortune 500 companies across North America.",
        image: "/Users/richh/.gemini/antigravity/brain/0ce2bc9d-c8c9-4df2-b842-ab95cbade1ed/team_member_1_1770060813716.png",
    },
    {
        name: "Sarah Chen",
        role: "Systems Administrator",
        description: "Sarah brings expertise in cloud infrastructure and system automation. She manages our clients' critical IT systems, ensuring 99.9% uptime and seamless operations across hybrid cloud environments.",
        image: "/Users/richh/.gemini/antigravity/brain/0ce2bc9d-c8c9-4df2-b842-ab95cbade1ed/team_member_2_1770060830794.png",
    },
    {
        name: "Carlos Rodriguez",
        role: "Wireless Specialist",
        description: "Carlos is our go-to expert for wireless site surveys and RF optimization. He has successfully deployed wireless networks in over 200 locations, from small offices to large campus environments.",
        image: "/Users/richh/.gemini/antigravity/brain/0ce2bc9d-c8c9-4df2-b842-ab95cbade1ed/team_member_3_1770060842341.png",
    },
    {
        name: "Emily Harrison",
        role: "Project Manager",
        description: "Emily coordinates our nationwide deployment projects, ensuring on-time delivery and client satisfaction. Her organizational skills and technical knowledge make complex rollouts seamless.",
        image: "/Users/richh/.gemini/antigravity/brain/0ce2bc9d-c8c9-4df2-b842-ab95cbade1ed/team_member_4_1770060855594.png",
    },
    {
        name: "Ahmed Hassan",
        role: "Support Technician",
        description: "Ahmed is part of our 24/7 support team, providing rapid response to technical issues. His troubleshooting expertise and customer-first approach ensure minimal downtime for our clients.",
        image: "/Users/richh/.gemini/antigravity/brain/0ce2bc9d-c8c9-4df2-b842-ab95cbade1ed/team_member_5_1770060867084.png",
    },
];

const HeroSection = () => (
    <Box
        sx={{
            position: "relative",
            height: { xs: "300px", sm: "400px", md: "500px" },
            overflow: "hidden",
            background: "linear-gradient(135deg, #000000 0%, #1a1a1a 50%, #facd00 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        }}
    >
        <motion.div
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
        >
            <Typography
                variant="h2"
                fontWeight="bold"
                sx={{
                    color: "#fff",
                    textAlign: "center",
                    textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
                    fontSize: { xs: "2rem", sm: "3rem", md: "4rem" },
                }}
            >
                Meet Our Team
            </Typography>
            <Typography
                variant="h5"
                mt={2}
                sx={{
                    color: "#facd00",
                    textAlign: "center",
                    textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
                    fontSize: { xs: "1rem", sm: "1.5rem", md: "2rem" },
                }}
            >
                Expert Professionals Delivering Excellence
            </Typography>
        </motion.div>
    </Box>
);

const TeamMemberCard = ({ member, index }) => (
    <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: index * 0.1 }}
    >
        <Card
            sx={{
                boxShadow: 4,
                borderRadius: 3,
                overflow: "hidden",
                height: "100%",
                transition: "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
                "&:hover": {
                    transform: "translateY(-10px)",
                    boxShadow: 8,
                },
            }}
        >
            <Box
                sx={{
                    background: "linear-gradient(135deg, #000000 0%, #facd00 100%)",
                    p: 3,
                    display: "flex",
                    justifyContent: "center",
                }}
            >
                <Avatar
                    src={member.image}
                    alt={member.name}
                    sx={{
                        width: { xs: 120, sm: 150, md: 180 },
                        height: { xs: 120, sm: 150, md: 180 },
                        border: "4px solid #fff",
                        boxShadow: 3,
                    }}
                />
            </Box>
            <CardContent sx={{ p: 3, textAlign: "center" }}>
                <Typography variant="h5" fontWeight="bold" gutterBottom>
                    {member.name}
                </Typography>
                <Typography
                    variant="subtitle1"
                    color="primary"
                    fontWeight="600"
                    sx={{ mb: 2, color: "#facd00" }}
                >
                    {member.role}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
                    {member.description}
                </Typography>
            </CardContent>
        </Card>
    </motion.div>
);

const TeamPage = () => {
    return (
        <>
            <HeroSection />
            <Container sx={{ py: 8 }}>
                <Box sx={{ mb: 6, textAlign: "center" }}>
                    <Typography variant="h3" fontWeight="bold" gutterBottom>
                        Our Expert Team
                    </Typography>
                    <Typography variant="h6" color="text.secondary" sx={{ maxWidth: "800px", mx: "auto" }}>
                        Data Speedway's team of certified professionals brings decades of combined experience
                        in network infrastructure, systems administration, and IT project management.
                    </Typography>
                </Box>
                <Grid container spacing={4}>
                    {teamMembers.map((member, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                            <TeamMemberCard member={member} index={index} />
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </>
    );
};

export default TeamPage;
